import { useCallback } from "react";
import { Button } from "@/components/Buttons/index";
import styles from "@/styles/Video.module.scss";
import { useChatEventGAPush } from "@/hooks";

export default function ChatSelect({
  setChatDisplay,
  setIsChatSelected,
  play,
  isLive,
  state,
}) {
  const handleStart = useCallback(() => {
    if (!play) return;
    if (isLive) state.updateResumePoint(0.1);
    else state.updateResumePoint(0);
  }, [play, isLive]);

  const { joinRoomEvent } = useChatEventGAPush();

  return (
    <div className={styles.resume}>
      <div className={styles.buttons}>
        <Button
          fillMainColor
          chatSelect
          fontBold
          onClick={() => {
            setChatDisplay(false);
            setIsChatSelected(true);
            handleStart();
          }}
        >
          ▶︎再生する
        </Button>
        <Button
          fillWhiteColor
          chatSelect
          fontBold
          onClick={() => {
            setChatDisplay(true);
            setIsChatSelected(true);
            handleStart();
            joinRoomEvent(state?.rooms?.[0]?.roomId);
          }}
        >
          ▶︎チャット付きで再生する
        </Button>
      </div>
    </div>
  );
}
